import {Injectable} from '@angular/core';
import {VerifyMagayaControlledGuard} from "./verify-magaya-controlled.guard";

@Injectable({
    providedIn: 'root'
})
export class CanCreateOrUpdatePortalUsersGuard extends VerifyMagayaControlledGuard {

}
